import { AnyAction } from 'redux';
import { GET_TOGGLER_SUCCESS, togglerType } from '../types/mdms';
import { LOGOUT_SUCCESS } from '../types/auth';
import { CREATE_APPLICATION_SUCCESS, GET_ALL_APPLICATION_SUCCESS } from '../types/application';

export type mdmsProp = {
  toggler: togglerType;
};

const initialState: mdmsProp = {
  toggler: {
    dateFeatureToggles: {
      nomineeRemovalAndDeclarationValidationDate: '',
      poaValidationDate: '',
      dematFieldValidationDate: '',
      dpIdFieldValidationDate: '',
    },
    fatcaMasterDataFeatureToggle: {},
  },
};

export const mdmsDataReducer = (state = initialState, action: AnyAction): mdmsProp => {
  switch (action.type) {
    case LOGOUT_SUCCESS:
    case GET_ALL_APPLICATION_SUCCESS:
    case CREATE_APPLICATION_SUCCESS: {
      return { ...initialState };
    }
    case GET_TOGGLER_SUCCESS: {
      return { ...state, toggler: action.body };
    }
    default:
      return state;
  }
};
